import React from 'react';

// Shared components
import { GeneralPackageForm } from './';
import { ChristmasPackageSummary } from './components/Summaries';

export const ChristmasCompanyPackageForm = (props) => {
  const { values, formContent } = props;

  const SummaryComponent = (innerProps) => {
    return (
      <ChristmasPackageSummary
        part={values.partOptions.currentPart}
        area={innerProps.area}
        image={formContent.packageImage}
        price={values.productOptions.product.price}
        packages={formContent.packages}
        activePackageId={values.product.id}
      />
    );
  };

  return <GeneralPackageForm summaryComponent={SummaryComponent} {...props} />;
};
